export default function PHP_hebrev() {
  return (
    <div>
      <h1>PHP_hebrev</h1>
    </div>
  );
}
